/* sets default ng-model-option on selects, checkboxes and radios - basically default debounce is set to 0 */
(function() {

    var select = function() {
        return {
            restrict: "E",
            replace: false,
            transclude: false,
            require: '?ngModel',
            link: function(scope, element, attrs, ngModelCtrl){

                // no debounce
                if( ngModelCtrl && !angular.isDefined(attrs.ngModelOptions) ) {
                    ngModelCtrl.$overrideModelOptions({
                        updateOn: 'default blur',
                        debounce: {
                            'blur': 0,
                            'default': 0
                        }
                    });
                }

            }
        };
    }
    angular.module('app').directive('select', select);


    var input = function() {
        return {
            restrict: "E",
            replace: false,
            transclude: false,
            require: '?ngModel',
            link: function(scope, element, attrs, ngModelCtrl){

                if( angular.isDefined(attrs.type) ) {

                    // ng-model-options
                    if( ngModelCtrl && !angular.isDefined(attrs.ngModelOptions) ) {
                        // no debounce for radio and checkbox
                        if(attrs.type=="checkbox" || attrs.type=="radio") {
                            ngModelCtrl.$overrideModelOptions({
                                updateOn: 'default blur',
                                debounce: {
                                    'blur': 0,
                                    'default': 0
                                }
                            });
                        } else if(attrs.type=='time' && cssua.ua.chrome) { // only on Chrome
                            ngModelCtrl.$overrideModelOptions({
                                updateOn: 'default keyup blur',
                                debounce: {
                                    'blur': 0,
                                    'default': 1000, // TODO: config
                                    'keyup': 1000 // TODO: config
                                }
                            });
                        } else if(attrs.type=="file") {
                            ngModelCtrl.$overrideModelOptions({
                                updateOn: 'default',
                                debounce: {
                                    'default': 1 // there's problem with clearing model if it's set to 0
                                }
                            });
                        } else {
                            // this is done for validation-warnings (part of xmsValidation)
                            // we need to set ngModelOptions individually - otherwise any access to $options sets them on global level...
                            // ... what breaks the validation once warnings set allowInvalid to true
                            ngModelCtrl.$overrideModelOptions({
                                updateOn: 'default blur',
                                debounce: {
                                    'blur': 0,
                                    'default': 1000 // TODO: config
                                }
                            });
                        }
                    }

                    // ignore mouse wheel on input[type=number] fields
                    if(attrs.type=="number"){
                        element.bind('mousewheel', function (event) {
                            element.blur();
                        });

                        if(ngModelCtrl) {
                            // ...remove the `step` validator (as of Angular 1.6 upgrade)
                            delete ngModelCtrl.$validators.step;
                        }
                    }

                    // time over 59 minutes validation
                    if(attrs.type=="time" && ngModelCtrl){
                        ngModelCtrl.$validators.maxminutes = function(modelValue) {
                            if(ngModelCtrl.$viewValue.split(":").pop() > 59){
                                return false;
                            }
                            return true;
                        };
                    }

                    // date over 12 months validation
                    if(attrs.type=="date" && ngModelCtrl){
                        ngModelCtrl.$validators.maxmonths = function(modelValue) {
                            if(ngModelCtrl.$viewValue!==null && ngModelCtrl.$viewValue.split("-")[1] > 12){
                                return false;
                            }
                            return true;
                        };
                    }

                }

                // A11Y fix - Dragon not updating model (not sure if it works...(?))
                var composing = false;
                element.on('compositionstart', function (data) {
                    composing = true;
                });
                element.on('compositionend', function () {
                    composing = false;
                });
                element.on('keydown keypress', function (event) {
                    if (composing) {
                        element.trigger('compositionend');
                    }
                });

            }
        };
    }
    angular.module('app').directive('input', input);


    var textarea = function() {
        return {
            restrict: "E",
            replace: false,
            transclude: false,
            require: '?ngModel',
            link: function(scope, element, attrs, ngModelCtrl){
                const maxlength = attrs.maxlength ? parseInt(attrs.maxlength) : null;
                // this is done for validation-warnings (part of xmsValidation)
                // we need to set ngModelOptions individually - otherwise any access to $options sets them on global level...
                // ... what breaks the validation once warnings set allowInvalid to true
                if( ngModelCtrl && !angular.isDefined(attrs.ngModelOptions) ) {
                    ngModelCtrl.$overrideModelOptions({
                        updateOn: 'default blur',
                        debounce: {
                            'blur': 0,
                            'default': 1000 // TODO: config
                        }
                    });
                }

                /**
                 * Adjust maxlength and value dynamically based on line breaks
                 * This prevents the issue where different line break styles take up different character counts in DB
                 */
                element.on('input', function () {
                    const elValue = element.val();
                    // Count occurrences of \r\n (Windows-style line breaks)
                    const crlfCount = (elValue.match(/\r\n/g) || []).length;
                    // Count occurrences of \r (old Mac-style line breaks)
                    const crCount = (elValue.match(/\r(?!\n)/g) || []).length;
                    // Count occurrences of \n (Unix/Linux-style line breaks)
                    const lfCount = (elValue.match(/(?<!\r)\n/g) || []).length;
                    // Adjust max length offset
                    const maxLengthOffset = (crlfCount * 4) + (crCount * 2) + (lfCount * 2);
                    const newMaxLength = maxlength ? maxlength - maxLengthOffset : null;
                    // Update the maxlength attribute on the element
                    element.attr('maxlength', newMaxLength);
                    // Trim the value if it exceeds the new max length
                    const trimmedValue = maxlength && newMaxLength >= 0 ? elValue.substring(0, newMaxLength) : elValue;
                    // Set the trimmed value back to the element
                    element.val(trimmedValue);
                });

                // A11Y fix - Dragon not updating model (not sure if it works...(?))
                var composing = false;
                element.on('compositionstart', function (data) {
                    composing = true;
                });
                element.on('compositionend', function () {
                    composing = false;
                });
                element.on('keydown keypress', function (event) {
                    if (composing) {
                        element.trigger('compositionend');
                    }
                });
            }
        }
    }
    angular.module('app').directive('textarea', textarea);

}());